import moment from 'moment'
import { isString } from 'lodash'


export const serializeSession = (() => {
  const lookupTable = new Map()
  return (lastScreen, session) => {
    const key = JSON.stringify(session)
    if(lookupTable.get(key) && session.lastScreenSaved === lastScreen) {
      return lookupTable.get(key)
    }
    const serializedSession = JSON.stringify(
      formatters.transmogrifySessionDataToApiDataObject(lastScreen, session)
    )
    lookupTable.set(key, serializedSession)
    return serializedSession
  }
})()

export const transmogrifyApiDataToSessionStore = apiResponse => {
  let transmogrifiedApiData = {
    ...apiResponse,
    factorsOption1: [],
    factorsOption2: [],
    topThreeFactors: [],
    topThreeFactorsWithAffectWeights: [],
    topThreeFactorsWithCompareWeights: [],
  }

  apiResponse.factors = apiResponse.factors.map(factor => isString(factor) ? factor : factor.toString())
  transmogrifiedApiData.factorsOption1 = apiResponse.factors.slice(0,5).filter(f => f !== '' )
  transmogrifiedApiData.factorsOption2 = apiResponse.factors.slice(5,10).filter(f => f !== '' )
  transmogrifiedApiData.isComplete = !!apiResponse.isComplete // map 0 or 1 to boolean

  apiResponse.topThreeFactors.forEach(factorIndex => {
    let factorString = apiResponse.factors[factorIndex]
    if ( factorString !== null && factorString !== undefined ) {
      transmogrifiedApiData.topThreeFactors.push(apiResponse.factors[factorIndex])
    }
  })

  apiResponse.topThreeWeights.forEach((weightValue, index) => {
    let factorString = transmogrifiedApiData.topThreeFactors[index]
    if ( factorString !== null && factorString !== undefined ) {
      transmogrifiedApiData.topThreeFactorsWithAffectWeights.push(
        {text: transmogrifiedApiData.topThreeFactors[index], weight: weightValue}
      )
    }
  })

  apiResponse.topThreeCompare.forEach((weightValue, index) => {
    let factorString = transmogrifiedApiData.topThreeFactors[index]
    if ( factorString !== null && factorString !== undefined ) {
      transmogrifiedApiData.topThreeFactorsWithCompareWeights.push(
        {text: transmogrifiedApiData.topThreeFactors[index], weight: weightValue}
      )
    }
  })

  if (apiResponse.dateOfBirth !== '') {
    transmogrifiedApiData.dateOfBirth = moment(apiResponse.dateOfBirth, 'MMMM DD YYYY HH:mm:ss').format('YYYY-MM-DD')
  }


  // NOTE: API returns a string with a space
  // Check for ' ', set value to `null`
  if (/\s/.test(apiResponse.gender)) {
    transmogrifiedApiData.gender = null
  }

  delete transmogrifiedApiData.factors
  delete transmogrifiedApiData.topThreeWeights
  delete transmogrifiedApiData.topThreeCompare

  return transmogrifiedApiData
}

export const transmogrifySessionDataToApiDataObject = (lastScreenSaved, sessionData) => {
  let transmogrifiedSessionData = {
    ...sessionData.counselingSessionData,
    factors: [],
    lastScreenSaved,
    topThreeFactors: [],
    topThreeWeights: [],
    topThreeCompare: [],
  }

  let filler1 = new Array(5 - sessionData.counselingSessionData.factorsOption1.length).fill('')
  let filler2 = new Array(5 - sessionData.counselingSessionData.factorsOption2.length).fill('')

  let factorsOption1WithEmptyStrings = sessionData.counselingSessionData.factorsOption1.concat(filler1)
  let factorsOption2WithEmptyStrings = sessionData.counselingSessionData.factorsOption2.concat(filler2)

  transmogrifiedSessionData.factors = factorsOption1WithEmptyStrings.concat(factorsOption2WithEmptyStrings)
  // map boolean to number
  transmogrifiedSessionData.isComplete = +(sessionData.counselingSessionData.isComplete)

  sessionData.counselingSessionData.topThreeFactors.forEach(factor => {
    transmogrifiedSessionData.topThreeFactors.push(transmogrifiedSessionData.factors.indexOf(factor))
  })
  while (transmogrifiedSessionData.topThreeFactors.length < 3 ) { transmogrifiedSessionData.topThreeFactors.push('') }

  sessionData.counselingSessionData.topThreeFactorsWithAffectWeights.forEach(factor => {
    transmogrifiedSessionData.topThreeWeights.push(factor.weight === null ? 0 : factor.weight)
  })
  while (transmogrifiedSessionData.topThreeWeights.length < 3 ) { transmogrifiedSessionData.topThreeWeights.push(0) }

  sessionData.counselingSessionData.topThreeFactorsWithCompareWeights.forEach(factor => {
    transmogrifiedSessionData.topThreeCompare.push(factor.weight === null ? 0 : factor.weight)
  })
  while (transmogrifiedSessionData.topThreeCompare.length < 3 ) { transmogrifiedSessionData.topThreeCompare.push(0) }

  if (sessionData.counselingSessionData.dateOfBirth !== '') {
    transmogrifiedSessionData.dateOfBirth = moment(sessionData.counselingSessionData.dateOfBirth).format('YYYY-MM-DD')
  }

  delete transmogrifiedSessionData.factorsOption1
  delete transmogrifiedSessionData.factorsOption2
  delete transmogrifiedSessionData.topThreeFactorsWithAffectWeights
  delete transmogrifiedSessionData.topThreeFactorsWithCompareWeights
  // NOTE: read-only attributes
  delete transmogrifiedSessionData.decisionName
  delete transmogrifiedSessionData.educationMaterials
  delete transmogrifiedSessionData.options
  delete transmogrifiedSessionData.optionsResults

  return transmogrifiedSessionData
}

// this export is needed for stubbing in unit test and is called by serializeSession
export const formatters = {
  transmogrifySessionDataToApiDataObject
}



// WEBPACK FOOTER //
// ./src/api/formatters.js